import { OptionProps } from "components/common/utlis/TypeAnnotations";

interface dropDownList {
    closingTypes: OptionProps[];
}

export const createFilterConfig = (dropDownList: dropDownList) => {
    return [
        {
            name: "company",
            fieldType: "text",
            placeholder: "Company",
            filterType: 'search'
        },
        {
            name: "startDate",
            fieldType: "date",
            placeholder: "Date",
            filterType: 'search'
        },
        {
            name: "endDate",
            fieldType: "date",
            placeholder: "Date",
            filterType: 'search'
        },
        {
            name: "closingType",
            options: dropDownList.closingTypes,
            fieldType: "singleSelect",
            placeholder: "Closure type",
            filterType: 'search'
        },
        {
            name: "info",
            fieldType: "text",
            placeholder: "Info",
            filterType: 'search',
        }
    ];
};